<div class="refund-data my-3 ms-3" [formGroup]="refundDataForm">
	<div class="refund-data__fields">
		<div class="refund-data__row">
			<mat-form-field appearance="outline">
				<mat-label>Imię</mat-label>
				<input type="text" matInput formControlName="firstName" />
			</mat-form-field>
			<mat-form-field appearance="outline">
				<mat-label>Nazwisko</mat-label>
				<input type="text" matInput formControlName="lastName" />
			</mat-form-field>
		</div>
		<mat-form-field appearance="outline" class="refund-data__bank">
			<mat-label>Nr konta bankowego</mat-label>
			<input type="text" matInput formControlName="bankAccount" />
		</mat-form-field>
	</div>
	<button mat-raised-button color="primary" type="button" (click)="save()">Zapisz</button>
</div>
